export function Label({ className = "", children, ...props }) {
  return (
    <label
      className={`text-sm font-medium leading-none text-foreground ${className}`}
      {...props}
    >
      {children}
    </label>
  )
}
